import { render, staticRenderFns } from "./pdf-view.vue?vue&type=template&id=478642aa&scoped=true"
import script from "./pdf-view.vue?vue&type=script&lang=js"
export * from "./pdf-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478642aa",
  null
  
)

export default component.exports